module.exports = __webpack_public_path__ + "img/6c50c75.png";